import React from 'react';
import { normalizeProductBadges, PRODUCT_BADGES } from '../Utils/productBadges';
import './ProductBadges.css';

type Props = { badges: unknown };

export default function ProductBadges({ badges }: Props) {
  const selected = normalizeProductBadges(badges);
  if (!selected.length) return null;
  return <div className="product-badges" role="list" aria-label="Destaques do produto">
    {PRODUCT_BADGES.filter(badge => selected.includes(badge.code)).map(badge => (
      <span key={badge.code} className="product-badge" role="listitem">{badge.label}</span>
    ))}
  </div>;
}
